import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle, FormGroup, Form, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import 'whatwg-fetch';
let recaptchaInstance;


export default class Contact extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      phone: "",
      message: "",
      prefersEmail: false,
      prefersPhone: false,
      captcha: "",
      nameValidated: false,
      emailValidated: false,
      phoneValidated: false,
      messageValidated: false,
      captchaValidated: false,
      allButCaptchaValidated: false,
      formCanSubmit: false,
      formSubmitFailed: false,
      formSubmitted: false
    };
  }

  setInputState = (event) => { this.setState({ [event.target.name]: event.target.value }, () => { this.setValidationState() }); }

  setCaptchaState = (value) => {
    // If user correctly solves captcha, then sits idle, it will become null. Reset it in that case.
    if(value == null) {
      recaptchaInstance.reset();
      this.setState({
         captcha: ""
      }, () => { this.setValidationState(); })
    }
    else {
      this.setState({
         captcha: value
      }, () => { this.setValidationState(); })
    }
  }

  canFormSubmit = () => {
    let allButCaptchaValidated = false;
    let formCanSubmit = false;

    this.state.nameValidated && this.state.emailValidated && 
    this.state.phoneValidated && this.state.messageValidated
    ? allButCaptchaValidated = true : allButCaptchaValidated = false;

    this.state.nameValidated && this.state.emailValidated && 
    this.state.phoneValidated && this.state.messageValidated && this.state.captchaValidated 
    ? formCanSubmit = true : formCanSubmit = false;

    this.setState({ allButCaptchaValidated, formCanSubmit });
  }

  setValidationState = () => {
    let nameValidated = false;
    let emailValidated = false;
    let phoneValidated = false;
    let messageValidated = false;
    let captchaValidated = false;
  
    this.state.name.length > 0 && this.state.name != null ? nameValidated = true : nameValidated = false;
    this.validateEmail(this.state.email) ? emailValidated = true : emailValidated = false;
    this.validatePhone(this.state.phone) ? phoneValidated = true : phoneValidated = false;
    this.state.message.length > 0 && this.state.message != null ? messageValidated = true : messageValidated = false;
    this.state.captcha.length > 0 && this.state.captcha != null ? captchaValidated = true : captchaValidated = false;

    this.setState({ nameValidated, emailValidated, phoneValidated, messageValidated, captchaValidated
    }, () =>  { this.canFormSubmit(); })
  }

  submitForm = () => {
    const currentFields = `Name: ${this.state.name}, Validated: ${this.state.nameValidated}
                          \nEmail: ${this.state.email}, Validated: ${this.state.emailValidated}
                          \nMessage: ${this.state.message}, Validated: ${this.state.messageValidated}
                          \nP_Email: ${this.state.prefersEmail}
                          \nP_Phone: ${this.state.prefersPhone}
                          \nCaptcha: ${this.state.captcha}, Validated: ${this.state.captchaValidated}
                          `;


      this.state.formCanSubmit
      ? this.successfulFormSubmit(currentFields)
      : this.failedFormSubmit()
  }

  successfulFormSubmit(currentFields) {
    //console.log("Submitting the following: " + currentFields);
    this.sendEmail();
    recaptchaInstance.reset();

    this.setState({
        formSubmitted: true,
        formSubmitFailed: false,
        formCanSubmit: false,
        name: "",
        email: "",
        phone: "",
        message: "",
        prefersEmail: false,
        prefersPhone: false,
        captcha: "",
        nameValidated: false,
        emailValidated: false,
        phoneValidated: false,
        messageValidated: false,
        captchaValidated: false,
        allButCaptchaValidated: false,
    });

  }
  failedFormSubmit = () => {
    console.log("One or more fields have an error. Please enter values according to the errors given above.")

    this.setState({
      formSubmitted: false,
      formSubmitFailed: true
    });
  }

  sendEmail = () => {
    var URL = 'https://tc2jqitrp6.execute-api.us-east-1.amazonaws.com/prod/message';
         
    var emailData = {
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      message: this.state.message,
      prefersEmail: this.state.prefersEmail,
      prefersPhone: this.state.prefersPhone
    };

    fetch(URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      body: JSON.stringify({emailData})
    })
    .then(function (response) {
      //console.log('Response: ' + response.json());
    })
    .then(function (result) {
      //console.log('Result: ' + result);
    })
    .catch(function(error) {
      //console.log('Error: ' + error);
    });
  }

  validateEmail = (value) => {
    let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regex.test(value);
  }
  validatePhone = (value) => {
    let validated = false;
    if(value.length > 6 && value.length < 20) { return value.match(/\d/g); }
    return validated;
  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
    	<FluidContainer  fluid>
        <Helmet>
          <title>Contact Us - Patterson Maple Farms</title>
        </Helmet>
        <InternalContainer>
	        
      		{/*ExampleObject*/}
      		<h1>Contact Us</h1>
          <p>Please fill out the form below and we will get back to you as soon as possible.</p>
          <AboveFormHR />
          <Form_s autoComplete="on">
            <FormGroup row>
              <Col xs="12" md="4" 
                  className={this.state.formSubmitFailed && !this.state.nameValidated ? "has-danger" : ""}>
                <Input name="name" placeholder="Name"
                  state={this.state.formSubmitFailed && !this.state.nameValidated ? "danger" : ""}
                  value={this.state.name} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.nameValidated ? 'block' : 'none'}}>
                  Please enter your name.
                </FormFeedback>
              </Col>
              <Col xs="12" md="4"
                className={this.state.formSubmitFailed && !this.state.emailValidated ? "has-danger" : ""} >
                <Input name="email" type="email" placeholder="Email Address" 
                  state={this.state.formSubmitFailed && !this.state.emailValidated ? "danger" : ""}
                  value={this.state.email} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.emailValidated ? 'block' : 'none'}}>
                  Please enter your email address.
                </FormFeedback>
              </Col>
              <Col xs="12" md="4"
                className={this.state.formSubmitFailed && !this.state.phoneValidated ? "has-danger" : ""} >
                <Input name="phone" placeholder="Phone Number" type="tel"
                  state={this.state.formSubmitFailed && !this.state.phoneValidated ? "danger" : ""}
                  value={this.state.phone} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.phoneValidated ? 'block' : 'none'}}>
                  Please enter your phone number.
                </FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col xs="12" md="12"
                className={this.state.formSubmitFailed && !this.state.messageValidated ? "has-danger" : ""} >
                <Input name="message" placeholder="Question or Message" type="textarea"
                  state={this.state.formSubmitFailed && !this.state.messageValidated ? "danger" : ""}
                  value={this.state.message} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.messageValidated ? 'block' : 'none'}}>
                  Please enter the question or message you would like to send us.
                </FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup row className="mt-3">
              <Col xs="5" sm="5" md="5" lg="4">
                <p>How would you prefer to be contacted?</p>
              </Col>
              <Col xs="3" sm="2" md="2" lg="1">
                <FormGroup check>
                  <Label check for="cbEmail">
                    <Input type="checkbox" id="cbEmail" checked={this.state.prefersEmail} 
                      onClick={ () => { this.setState({prefersEmail: !this.state.prefersEmail}); }}  /> 
                    {' '} Email
                  </Label>
                </FormGroup>
              </Col>
              <Col xs="4" sm="3" md="2" lg="1">
                <FormGroup check>
                  <Label check for="cbPhone">
                    <Input type="checkbox" id="cbPhone" checked={this.state.prefersPhone}
                      onClick={ () => { this.setState({prefersPhone: !this.state.prefersPhone}); }}  /> 
                    {' '} Phone
                  </Label>
                </FormGroup>
              </Col>
            </FormGroup>
            <FormGroupLast row>
              <CaptchaCol xs="12"
                className={this.state.formSubmitFailed && !this.state.captchaValidated &&
                       this.state.allButCaptchaValidated ? "has-danger" : ""} >
                <ReCAPTCHA id="captcha"
                  style={{display: !this.state.allButCaptchaValidated ? 'none' : 'block'}}
                  ref={e => recaptchaInstance = e}
                  sitekey="6LciHkQUAAAAAFMMEDt7jqLAPBZ_k6efeMuwGZGK"
                  onChange={this.setCaptchaState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.captchaValidated && 
                                      this.state.allButCaptchaValidated ? 'block' : 'none'}}>
                  Please successfully complete the captcha.
                </FormFeedback>
              </CaptchaCol>
              <SendBtnCol xs="12">
                <Button type="button" onClick={this.submitForm}>
                  <p>SEND</p>
                </Button>
                <LeavesByButton src={require("../media/leavespng1.png")}></LeavesByButton>
              </SendBtnCol>
            </FormGroupLast>
            <FormGroupSubmissionResultRow row className="mb-0">
              <Col xs="12">
                <SuccessfulSubmissionP style={{display: !this.state.formSubmitted ? 'none' : 'block'}} >
                  Message has been sent successfully. Thank you!</SuccessfulSubmissionP>
                <p style={{display: !this.state.formSubmitFailed ? 'none' : 'block'}} className="text-danger">
                  One or more fields have not been filled out correctly. 
                  Please review them and try to send again.</p>
              </Col>
            </FormGroupSubmissionResultRow>
          </Form_s>
          
          {/*<BelowFormHR/>*/}
          {/*
          <LocationInfoDiv>
            <p>Patterson Maple Farms</p>
            <p>Westfield, PA 16950</p>
            <p>(814)-628-3751</p>
            <a target="_blank" href="https://www.google.com/maps/place/Patterson+Maple+Farms/@41.8474617,-77.5351781,18z/data=!3m1!4b1!4m5!3m4!1s0x89ce20414219c9bb:0x99fe70447a64bc64!8m2!3d41.8474601!4d-77.5343149">
              Google Maps Directions</a>
          </LocationInfoDiv>
        */}
        </InternalContainer>
      </FluidContainer>
		);
	}
}

const LeavesByButton = styled.img`
  width: 80px;
  float: right;
  margin-top: -19px;
  display: inline;
`;

const SuccessfulSubmissionP = styled.p`
  color: green;
`;

const AboveFormHR = styled.hr` border-top-width: 2px; margin: -10px 0 0 0; `;
const BelowFormHR = styled.hr` border-top-width: 2px; margin: 0 0 24px 0; `;

const FormGroupSubmissionResultRow = styled(FormGroup)` text-align: center;` ;

const CaptchaCol = styled(Col)`
    padding: 0;
    margin: 20px 15px 0 15px;
    transform: scale(0.77);
    transform-origin: 0 0;
`;

const SendBtnCol = styled(Col)`
  Button {
    cursor: pointer;
    display: inline-block;
    border: 0px!important;
    color: white!important;
    font-weight: bold!important;
    background-color: #800000!important;
    width: 180px!important;
    height: 40px!important;
    line-height: 20px!important;
    transition: all 0.5s;

    p {
      cursor: pointer;
      display: inline;
      position: relative;
      transition: 0.5s;
    }

    p:after {
      content: '\00bb';
      position: absolute;
      opacity: 0;
      transition: 0.5s;
      right: -20px;
    }

    :hover p { padding-right: 25px; }
    :hover p:after { opacity: 1; right: 0; }

    :active p:after { opacity: 0; }
    :active { box-shadow: 0 5px #666; transform: translateY(6px); }
  }
`;

const FormGroupLast = styled(FormGroup)`
    margin-bottom: 0;
    padding-bottom: 15px;
`;

const Form_s = styled(Form)`
    text-align: left;
    font-size: 18px;
    margin-top: 30px;

    .row {
      margin-bottom: 0;
      
      .col-12 {
        margin-bottom: 10px;

        input, textarea {
          border-style: none none solid none;
          border-color: black black black black;
          border-radius: 0;
          background-color: transparent;
          padding-left: 0;
          font-family: 'Short Stack';
          font-size: 18px;
          box-shadow: none;
          color: black;

          :-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:active, :-webkit-autofill:focus { transition: background-color 5000s ease-in-out 0s; }

          &::placeholder {
            color: #464a4c;
          }
        } 
      }
    }
`;

const LocationInfoDiv = styled.div`
  p {
    margin: 0;
  }
`;

const FluidContainer = styled(Container)` padding: 30px 0 0 0!important;  `;
const InternalContainer = styled(Container)` h1 {color: black!important;}  `;

//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
`;
*/



// WEBPACK FOOTER //
// ./src/pages/Contact.js